import styled from 'styled-components/native';
import {RFValue} from 'react-native-responsive-fontsize';

export const Container = styled.View`
  border-style: solid;
  border-bottom-width: 1px;
  border-bottom-color: ${({theme}) => theme.colors.border};
  padding-bottom: ${RFValue(12)}px;
  margin-bottom: ${RFValue(12)}px;
`;

export const SectionHeader = styled.View`
  width: 100%;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const SectionTitleGroup = styled.View`
  flex-direction: column;
  align-items: flex-start;
`;

export const SectionSubtitle = styled.Text`
  font-family: ${({theme}) => theme.fonts.regular};
  color: ${({theme}) => theme.colors.text};
  font-size: ${RFValue(10)}px;
`;

export const SectionBannerContainer = styled.View`
  flex-direction: row;
  justify-content: flex-end;
  width: ${RFValue(165)}px;
`;

export const Title = styled.Text`
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({theme}) => theme.colors.title};
  font-size: ${RFValue(14)}px;
  margin-bottom: ${RFValue(4)}px;
`;

export const RescueHelperContainer = styled.View`
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;

  background-color: ${({theme}) => theme.colors.alert_blue_bg};
  border-width: 1px;
  border-color: ${({theme}) => theme.colors.alert_blue_border};
  padding: ${RFValue(6)}px ${RFValue(12)}px;
  border-radius: ${RFValue(18)}px;
  margin-top: ${RFValue(10)}px;
  
`;

export const RescueHelperText = styled.Text`
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({theme}) => theme.colors.alert_blue_title};
  font-size: ${RFValue(10)}px;
  margin-left: ${RFValue(6)}px;
`;
